import {
  SingleSelectForm as SharedSingleSelectForm,
  type SingleSelectFormProps as SharedSingleSelectFormProps,
} from '@github-ui/shared-single-select-components/SingleSelectForm'

import {getInitialState} from '../../../helpers/initial-state'

type SingleSelectFormProps = Omit<SharedSingleSelectFormProps, 'maxNumberOfOptions'>

export const SingleSelectForm = (props: SingleSelectFormProps) => {
  const {
    projectLimits: {singleSelectColumnOptionsLimit},
  } = getInitialState()

  return <SharedSingleSelectForm {...props} maxNumberOfOptions={singleSelectColumnOptionsLimit} />
}
